<template>
    <div class="newsView content-part">
         <div class="news-banner">
             <img src="https://1.rc.xiniu.com/rc/Banners/6670/images/ibpsp1_news_banner.jpg">
         </div>
         <div class="news-contain">
             <div class="n-main">
                 <p class="title">{{title}}</p>
                 <div class="share">
                    <div class="share-left">
                        <p>日期： {{date}}</p>
                        <!-- <p>浏览次数: 135</p> -->
                    </div>
                    <div class="share-right"></div>
                </div>
                <!-- <div class="desc">
                    临近春节尾声，新冠肺炎疫情随着返工潮迎来一波小爆发，全国确诊人数突破两万，电梯、
                    暖通空调系统等商业办公必需品成为疫情传播的高危因素。对于未来需要在写字楼、商场办公生活的人群如何“抗疫”？
                </div> -->
                <div v-html='content' class="desc"></div>
             </div>
         </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            id:'',
            content:'',
            title:'',
            date:''
        }
    },
    mounted(){
        if(this.$route.query.id){
            this.id=this.$route.query.id
            this.getDetail()
        }else{
            this.$router.push('/news')
        }
    },
    methods:{
        getDetail(){
            this.$http.get('/api/portal/news/query',{
                params:{
                    id:this.id
                }
            }).then((res)=>{
                // console.log(res)
                this.content=res.data&&res.data.content?res.data.content:''
                this.title=res.data&&res.data.title?res.data.title:''
                this.date=res.data&&res.data.createDate?this.$moment(res.data.createDate).format('YYYY-MM-DD'):''
            })
        }
    }
}
</script>

<style lang="less">
.newsView{
    .news-banner{
        width: 100%;
        height: 355px;
        img{
            width: 100%;
            height: 355px;
        }
    }
    .news-contain{
        width: 100%;
        min-width: 1200px;
        .n-main{
            width: 1000px;
            margin: 0 auto 30px;
            padding: 0;
            height: auto;
            border: 1px solid #e9e9e9;
            box-sizing: border-box;
            padding: 58px 54px;
            border-top: 0;
            p.title{
                height: 45px;
                line-height: 45px;
                overflow: hidden;
                font-size: 30px;
                color: #000000;
                font-weight: bold;
            }
            .share{
                width: 100%;
                display: flex;
                height: 27px;
                line-height: 27px;
                font-size: 12px;
                box-sizing: border-box;
                padding-bottom: 4px;
                border-bottom: 1px solid #dc382e;
                justify-content: space-between;
                margin-top: 20px;
                .share-left{
                    p{
                        font-size: 12px;
                        color: #0080ff;
                        line-height: 27px;
                        display: inline-block;
                    }
                    // p:last-child{
                    //     margin-left: 60px;
                    // }
                }
            }
            .desc{
                box-sizing: border-box;
                padding: 50px 0 50px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/view/newsView.vue